export default "__VITE_ASSET__lFQjKSlu__"